
import React from "react";
import { RoleBadge } from "@/components/RoleBadge";
import { formatDistanceToNow } from "date-fns";
import { ProfileAvatar } from "./ProfileAvatar";

interface ProfileHeaderProps {
  userId: string;
  profile: any;
  user: any;
  role: string;
  avatarUrl: string | null;
  readOnly?: boolean;
  onAvatarUpdated: (url: string | null) => void;
}

export function ProfileHeader({
  userId,
  profile,
  user,
  role,
  avatarUrl,
  readOnly = false,
  onAvatarUpdated
}: ProfileHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row gap-6 items-start">
      <ProfileAvatar 
        userId={userId}
        avatarUrl={avatarUrl}
        fullName={profile?.full_name}
        email={user?.email}
        readOnly={readOnly}
        onAvatarUpdated={onAvatarUpdated}
      />
      
      <div className="space-y-3 flex-1">
        <div>
          <h3 className="text-lg font-semibold">
            {profile?.full_name || "No name set"}
          </h3>
          <p className="text-slate-500">{user?.email}</p>
        </div>
        
        <div className="flex flex-wrap gap-2 items-center">
          <RoleBadge role={role as any} />
          {profile?.created_at && (
            <span className="text-xs text-slate-500">
              Joined {formatDistanceToNow(new Date(profile.created_at), { addSuffix: true })}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
